export default __webpack_public_path__ + "static/newsletter-image-cad102664a1e6e82eddcfd510c042c68.jpg";